import { SyncExport } from '@/pages/SyncExport/SyncExport'
import { SyncImport } from '@/pages/SyncImport/SyncImport'
import { ErrorBoundary } from '../ErrorBoundary'
import { MessagesApplicationsApplication } from '@/dotnet-client'

type AppSyncPanelProps = {
  app: MessagesApplicationsApplication
}

export const AppSyncPanel = (props: AppSyncPanelProps) => {
  return (
    <ErrorBoundary>
      <div className="application-cards">
        <div className="application-card">
          <div className="application-content">
            <SyncExport {...props} />
          </div>
        </div>
        <div className="application-card">
          <div className="application-content">
            <SyncImport {...props} />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}
